import React from 'react';
import {useAuthToken} from '../../auth';
import {hasValidAccessToken} from '../../auth/functions';
import {AuthTokens} from '../../auth/types';

type AuthTokenProp = {authTokens: AuthTokens | undefined};

export const withAuthTokens = <PropType extends AuthTokenProp>(
  Component: React.ComponentType<PropType>,
) => {
  return (props: Omit<PropType, 'authTokens'>) => {
    const authTokens = useAuthToken();
    return hasValidAccessToken(authTokens) ? (
      <Component {...(props as PropType)} authTokens={authTokens} />
    ) : null;
  };
};
